(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks68-picker"]) return;
  try {
    
(()=>{
function init(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const data=JSON.parse(root.querySelector('[data-kp-data]').textContent),c=JSON.parse(root.querySelector('[data-kp-copy]').textContent);
 if(!data.supported)return;

 const panel=root.querySelector('[data-panel]'),next=root.querySelector('[data-next]'),error=root.querySelector('[data-error]');
 const state={step:1,pendant:null,set:null,variant:null,pouch:null,bracelet:null,extras:[],busy:false,submitted:false};
 const banner=root.querySelector('.kp-countdown'),header=document.querySelector('.main-nav');
 function syncBanner(){
  if(!root.isConnected)return;
  if(header){
   const layout=getComputedStyle(header),top=parseFloat(layout.top),height=header.offsetHeight;
   if(Number.isFinite(top)&&height>0)root.style.setProperty('--kp-header-bottom',Math.max(0,top+height)+'px');
  }
  if(banner.getBoundingClientRect().height)root.style.setProperty('--kp-banner-height',banner.getBoundingClientRect().height+'px');
 }
 syncBanner();
 const bannerObserver=new ResizeObserver(syncBanner);
 bannerObserver.observe(banner);if(header)bannerObserver.observe(header);
 window.addEventListener('resize',syncBanner,{passive:true});
 window.addEventListener('pageshow',syncBanner);
 window.visualViewport?.addEventListener('resize',syncBanner,{passive:true});
 document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){bannerObserver.disconnect();window.removeEventListener('resize',syncBanner);window.removeEventListener('pageshow',syncBanner);window.visualViewport?.removeEventListener('resize',syncBanner);}});
 const expired=()=>Date.now()>=data.deadline;
 function updateDeadline(){
  const closed=expired();
  root.querySelector('[data-offer-content]').hidden=closed;
  root.querySelector('[data-offer-ended]').hidden=!closed;
  if(closed){
   next.disabled=true;
   document.querySelectorAll('[data-kp-deadline-announcement]').forEach(el=>{el.textContent=c.offer_ended;});
   return;
  }
  const seconds=Math.max(0,Math.ceil((data.deadline-Date.now())/1000));
  const parts=[Math.floor(seconds/86400),Math.floor(seconds%86400/3600),Math.floor(seconds%3600/60),seconds%60];
  root.querySelectorAll('[data-countdown-value]').forEach((el,i)=>{el.textContent=String(parts[i]).padStart(2,'0');});
 }
 updateDeadline();
 const clock=setInterval(()=>{if(!root.isConnected){clearInterval(clock);return;}updateDeadline();},1000);
 window.addEventListener('pageshow',updateDeadline);
 document.addEventListener('visibilitychange',updateDeadline);
 const storage='kinsora-set-picker-v1',base=data.root.endsWith('/')?data.root:data.root+'/',money=v=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:data.currency,currencyDisplay:data.currency==='USD'?'narrowSymbol':'code'}).format(v/100);
 const short=t=>t.replace(/ (Heart|Cross|Lock) Pendant$/,'');
 const available=p=>p&&p.variants.some(v=>v.available),variant=p=>p.variants.find(v=>v.available);
 const sets=()=>data.sets.filter(p=>state.pendant&&p.title.endsWith(' + '+state.pendant.title));
 const trioIncomplete=()=>state.extras.length>0&&state.extras.length!==3;
 const trioPrompt=()=>c.trio_choose+' '+(3-state.extras.length)+' '+c.trio_more;
 const setRetail=()=>state.variant?.price||state.set?.variants.find(v=>v.available)?.price||data.sets.find(available)?.variants.find(v=>v.available)?.price||0;
 const setPrice=()=>Math.round(setRetail()*0.8);
 const setLabel=()=>c.set_price+' · '+money(setPrice());
 const amount=()=>setPrice()+(state.extras.length===3?Math.max(...state.extras.map(id=>variant(data.pendants.find(p=>p.id===id)).price)):0);
 function node(tag,text,cls){const n=document.createElement(tag);if(text!=null)n.textContent=text;if(cls)n.className=cls;return n;}
 function img(url,title){const n=node('img');if(url)n.src=url;n.alt=title||'';n.width=640;n.height=640;n.loading='lazy';return n;}
 function track(action,extra={}){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'set_picker_'+action,step:state.step,pendant_id:state.pendant?.id||null,set_id:state.set?.id||null,...extra});}
 function save(){try{sessionStorage.setItem(storage,JSON.stringify({pendant:state.pendant?.id,set:state.set?.id,variant:state.variant?.id,pouch:state.pouch,bracelet:state.bracelet,extras:state.extras}));}catch(e){}}
 function restore(){try{const s=JSON.parse(sessionStorage.getItem(storage)||'null');if(!s)return;state.pendant=data.pendants.find(p=>p.id===s.pendant&&available(p))||null;state.set=sets().find(p=>p.id===s.set&&available(p))||null;state.variant=state.set?.variants.find(v=>v.id===s.variant&&v.available)||null;for(const role of ['pouch','bracelet']){const list=data[role==='pouch'?'pouches':'bracelets'];if(list.some(v=>v.id===s[role]&&v.available))state[role]=s[role];}state.extras=data.pendants.filter(p=>(s.extras||[]).includes(p.id)&&available(p)).slice(0,3).map(p=>p.id);}catch(e){}}
 function go(step){if(state.busy||state.submitted)return;state.step=step;render();root.querySelector('[data-heading]').focus({preventScroll:true});root.querySelector('[data-heading]').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});track('step');}
 function card(p,selected,disabled,onClick,label){const b=node('button',null,'kp-card');b.type='button';b.disabled=disabled;b.setAttribute('aria-pressed',String(selected));const wrap=node('span',null,'kp-image');wrap.append(img(p.image,p.title));b.append(wrap,node('span',label||short(p.title),'kp-name'));if(disabled)b.append(node('small',c.sold_out));b.addEventListener('click',onClick);return b;}
 function field(title){const f=node('fieldset',null,'kp-fieldset');f.append(node('legend',title));return f;}
 function render(){
 save();panel.inert=state.busy||state.submitted;panel.replaceChildren();error.hidden=true;root.querySelector('[data-recovery]').hidden=!state.submitted;
 root.querySelectorAll('[data-step]').forEach(b=>{const s=Number(b.dataset.step);b.disabled=state.busy||state.submitted||(s===2&&!state.pendant)||(s===3&&!state.variant);if(s===state.step)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});
 root.querySelector('[data-heading]').textContent=[c.start,c.chain_heading,c.gift_heading][state.step-1];root.querySelector('[data-instruction]').textContent=[c.start_help,c.chain_help,c.gift_help][state.step-1];
 const summary=root.querySelector('[data-selection]');summary.replaceChildren();summary.hidden=state.step===1;const chosen=state.set||state.pendant;if(chosen&&state.step>1){summary.append(img(chosen.image,chosen.title));const copy=node('div');copy.append(node('strong',chosen.title),node('small',setLabel()));summary.append(copy);}
 if(state.step===1){const grid=node('div',null,'kp-grid');data.pendants.forEach(p=>grid.append(card(p,state.pendant?.id===p.id,!available(p)||!data.sets.some(s=>s.title.endsWith(' + '+p.title)&&available(s)),()=>{if(state.pendant?.id!==p.id){state.pendant=p;state.set=null;state.variant=null;}render();track('pendant');})));panel.append(grid);}
 if(state.step===2){const grid=node('div',null,'kp-grid kp-chain-grid');sets().sort((a,b)=>['Paperclip','Cable','Pearl','Snake'].indexOf(a.title.split(' ')[0])-['Paperclip','Cable','Pearl','Snake'].indexOf(b.title.split(' ')[0])).forEach(p=>grid.append(card(p,state.set?.id===p.id,!available(p),()=>{state.set=p;state.variant=p.variants.length===1?variant(p):null;render();track('chain');},p.title.split(' + ')[0])));panel.append(grid);if(state.set&&state.set.variants.length>1){const f=field(c.choose_length),buttons=node('div',null,'kp-lengths');state.set.variants.forEach(v=>{const b=node('button',v.title);b.type='button';b.disabled=!v.available;b.setAttribute('aria-pressed',String(state.variant?.id===v.id));b.onclick=()=>{state.variant=v;render();track('length');};buttons.append(b);});f.append(buttons);panel.append(f);}}
 if(state.step===3){for(const role of ['pouch','bracelet']){const f=field(c[role]+' · '+c.included),grid=node('div',null,'kp-grid kp-gift-grid');data[role==='pouch'?'pouches':'bracelets'].forEach(v=>grid.append(card(v,state[role]===v.id,!v.available,()=>{state[role]=v.id;render();track('gift',{gift_role:role});},v.title)));f.append(grid);panel.append(f);}
 const ups=node('div',null,'kp-upsells');ups.append(node('h3',c.optional));const catalogPrices=data.pendants.filter(available).map(p=>variant(p).price),uniform=catalogPrices.length>=3&&catalogPrices.every(p=>p===catalogPrices[0]),selectedPrices=state.extras.map(id=>variant(data.pendants.find(p=>p.id===id)).price),offerPrices=state.extras.length===3?selectedPrices:uniform?Array(3).fill(catalogPrices[0]):null;const priceLine=node('div',null,'kp-trio-price');if(offerPrices){const charge=Math.max(...offerPrices),value=offerPrices.reduce((a,b)=>a+b,0);priceLine.append(node('strong',money(charge)),node('span',money(value)+' '+c.trio_value,'kp-trio-value'),node('span',c.trio_save+' '+money(value-charge),'kp-trio-save'));}else{priceLine.append(node('span',c.trio_price_pending));}ups.append(priceLine,node('p',c.optional_help));const controls=node('div',null,'kp-trio-controls');const progress=node('p',state.extras.length+'/3 '+c.trio_selected);progress.setAttribute('role','status');controls.append(progress);if(state.extras.length){const skip=node('button',c.trio_skip,'kp-trio-skip');skip.type='button';skip.onclick=()=>{state.extras=[];render();track('upsell',{selected:false,skipped:true});};controls.append(skip);}ups.append(controls);data.pendants.forEach(p=>{const selected=state.extras.includes(p.id);if(state.extras.length===3&&!selected)return;const row=node('div',null,'kp-upsell');row.classList.toggle('is-selected',selected);row.append(img(p.image,p.title));const copy=node('div');copy.append(node('strong',short(p.title)),node('small',selected?'✓ '+c.chosen:c.trio_option));row.append(copy);const b=node('button',selected?c.remove:c.add);b.type='button';b.disabled=!available(p);b.setAttribute('aria-pressed',String(selected));b.setAttribute('aria-label',(selected?c.remove:c.add)+' '+p.title);b.onclick=()=>{state.extras=selected?state.extras.filter(id=>id!==p.id):state.extras.concat(p.id).slice(0,3);render();track('upsell',{product_id:p.id,selected:!selected});};row.append(b);ups.append(row);});panel.append(ups);}
 const orderSummary=root.querySelector('[data-order-summary]');orderSummary.replaceChildren();orderSummary.hidden=state.step!==3;
 if(state.step===3){
 const row=(label,value,cls='')=>{const r=node('div',null,'kp-summary-row '+cls);r.append(node('span',label),node('span',value));orderSummary.append(r);};
 const discountedRow=(label,retail,price,note)=>{const r=node('div',null,'kp-summary-row'),description=node('span'),prices=node('span',null,'kp-summary-prices');description.append(node('span',label),node('small',note,'kp-summary-discount'));prices.append(node('s',money(retail)),node('span',money(price)));r.append(description,prices);orderSummary.append(r);};
 discountedRow(c.summary_set,setRetail(),setPrice(),c.trio_save+' '+money(setRetail()-setPrice())+' · '+c.hero_savings);row(c.summary_gifts,c.included);let totalSavings=setRetail()-setPrice();
 if(state.extras.length===3){const retail=state.extras.reduce((sum,id)=>sum+variant(data.pendants.find(p=>p.id===id)).price,0),price=amount()-setPrice();totalSavings+=retail-price;discountedRow(c.summary_extras,retail,price,c.trio_save+' '+money(retail-price));}else if(trioIncomplete()){row(c.trio_pending+' ('+state.extras.length+'/3)',trioPrompt());}
 row(c.summary_shipping,c.shipping_free);row(c.summary_saved,money(totalSavings),'kp-summary-saving');row(c.summary_total,money(amount()),'kp-summary-grand');const installment=root.querySelector('[data-installments-template]').content.cloneNode(true);
 const domestic=data.currency==='USD'&&data.country==='US';
 installment.querySelector('[data-installment-copy]').textContent=domestic?c.installment_four:c.installment_options;
 installment.querySelector('[data-installment-amount]').textContent=domestic?money(amount()/4):'';
 orderSummary.append(installment);
 }
 root.querySelector('[data-total]').hidden=state.step===3;
 root.querySelector('[data-total]').textContent=state.step===3?c.summary_total+' · '+money(amount()):setLabel();
 next.textContent=state.busy?c.processing+' · '+money(amount()):[c.choose_chain,c.choose_gifts,trioIncomplete()?trioPrompt():c.summary_checkout+' · '+money(amount())+' →'][state.step-1];next.disabled=state.busy||state.submitted||(state.step===1&&!state.pendant)||(state.step===2&&!state.variant)||(state.step===3&&(!state.pouch||!state.bracelet||trioIncomplete()));
 if(state.busy||state.submitted)panel.querySelectorAll('button').forEach(b=>{b.disabled=true;});
 }
 async function readCart(){const r=await fetch(base+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!r.ok)throw Error(c.error);return r.json();}
 async function checkout(){
 if(expired()){updateDeadline();return;}
 if(state.busy||state.submitted||!state.variant||!state.pouch||!state.bracelet||trioIncomplete())return;
 state.busy=true;render();const k=window.Kinsora;let sent=false;
 try{
 if(!k?.runWhenSynchronizedPaidCartMutationReady)throw Error(c.unavailable);
 const token='kp-'+Date.now()+'-'+Math.random().toString(36).slice(2),expected=[state.variant.id,...state.extras.map(id=>variant(data.pendants.find(p=>p.id===id)).id)];
 let previousItems=[];
 const operation=async()=>{
 if(!k.setPreferredFreeGiftVariant?.('pouch',state.pouch)||!k.setPreferredFreeGiftVariant?.('bracelet',state.bracelet))throw Error(c.unavailable);
 const items=expected.map((id,i)=>({id,quantity:1,properties:{_kinsora_cart_unit:token+'-'+i,_kinsora_set_picker:token}}));
 const before=await readCart();if(before.currency!==data.currency)throw Error(c.error);
 previousItems=before.items.map(i=>({variant_id:Number(i.variant_id),quantity:i.quantity,properties:i.properties||{}}));
 for(const role of ['pouch','bracelet']){if(!before.items.some(i=>i.properties?._kinsora_free_gift_role===role||Number(i.variant_id)===state[role]))items.push({id:state[role],quantity:1,properties:{_kinsora_free_gift:'true',_kinsora_free_gift_role:role}});}
 if(expired()){updateDeadline();throw Error(c.offer_ended);}
 sent=true;state.submitted=true;
 const r=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});if(!r.ok){const body=await r.json();throw Error(body.description||c.error);}await r.json();return readCart();
 };
 operation.kinsoraVerifyCanonicalCart=cart=>{const added=cart.items.filter(i=>i.properties?._kinsora_set_picker===token);if(expected.some(id=>!added.some(i=>Number(i.variant_id)===id&&i.quantity===1)))throw Error(c.error);};
 operation.kinsoraDirectCheckout=true;
 operation.kinsoraVerifyDirectCheckout=cart=>{
 operation.kinsoraVerifyCanonicalCart(cart);
 if(cart.currency!==data.currency||!Number.isFinite(cart.total_price))throw Error(c.error);
 for(const role of ['pouch','bracelet']){const matches=cart.items.filter(i=>i.properties?._kinsora_free_gift_role===role);if(matches.length!==1||Number(matches[0].variant_id)!==state[role]||matches[0].quantity!==1||matches[0].properties?._kinsora_free_gift!=='true'||matches[0].final_line_price!==0)throw Error(c.error);}
 const added=cart.items.filter(i=>i.properties?._kinsora_set_picker===token);
 if(added.length!==expected.length||added.some(i=>!Number.isFinite(i.final_line_price)||i.final_line_price<0)||added.reduce((sum,i)=>sum+i.final_line_price,0)>amount())throw Error(c.error);
 const propsEqual=(a,b)=>{const keys=Object.keys(a);return keys.length===Object.keys(b).length&&keys.every(key=>String(a[key])===String(b[key]));};
 if(previousItems.some(old=>!cart.items.some(i=>Number(i.variant_id)===old.variant_id&&i.quantity>=old.quantity&&propsEqual(i.properties||{},old.properties))))throw Error(c.error);
 return true;
 };
 let cart=await k.runWhenSynchronizedPaidCartMutationReady(operation);
 let giftsChanged=false;
 for(const role of ['pouch','bracelet']){const selected=cart.items.find(i=>i.properties?._kinsora_free_gift_role===role&&i.properties?._kinsora_free_gift==='true'&&Number(i.variant_id)===state[role]&&i.final_line_price===0);if(!selected){cart=await k.swapFreeGift(role,state[role]);giftsChanged=true;}}
 if(giftsChanged)cart=await k.ensureCanonicalGiftState('set-picker-checkout');
 if(!cart?.items)cart=await readCart();operation.kinsoraVerifyCanonicalCart(cart);
 for(const role of ['pouch','bracelet'])if(!cart.items.some(i=>Number(i.variant_id)===state[role]&&i.properties?._kinsora_free_gift==='true'&&i.final_line_price===0))throw Error(c.error);
 const added=cart.items.filter(i=>i.properties?._kinsora_set_picker===token);if(cart.currency!==data.currency||added.reduce((sum,i)=>sum+i.final_line_price,0)>amount())throw Error(c.error);
 try{sessionStorage.removeItem(storage);}catch(e){}track('checkout',{value:cart.total_price/100,currency:cart.currency});window.location.assign(base+'checkout');
 }catch(e){state.busy=false;render();error.textContent=(e.message||c.error)+(sent?' '+c.review_cart:'');error.hidden=false;root.querySelector('[data-recovery]').hidden=!sent;error.scrollIntoView({block:'center'});track('error');}
 }
 window.addEventListener('pageshow',e=>{if(e.persisted&&state.submitted){state.busy=false;render();error.textContent=c.review_cart;error.hidden=false;root.querySelector('[data-recovery]').hidden=false;}});
 root.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.step))));next.addEventListener('click',()=>state.step<3?go(state.step+1):checkout());restore();render();track('view');
}
document.querySelectorAll('[data-kp]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-kp]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sets-landing"]) return;
  try {
    
document.addEventListener('change', function(event) {
  if (event.target.matches('[data-ks68-sort]') && event.target.form) event.target.form.requestSubmit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["worn-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Shared fullscreen player. Tapping a video card opens the clip full-size with a
  // clean custom UI: tap to play/pause, a mute toggle, a progress bar, and prev/next
  // (arrows, arrow keys, or swipe) to move between clips without closing. Opens with
  // sound on. One overlay is built once and reused for every rail.
  var _wlb = null, _wlbList = [], _wlbIdx = 0;
  function _wlbClose() {
    if (!_wlb) return;
    _wlb.classList.remove('is-open');
    var v = _wlb.__v; try { v.pause(); } catch (e) {}
    v.removeAttribute('src'); v.load();
    document.documentElement.style.overflow = ''; document.body.style.overflow = '';
  }
  function _wlbGo(d) { var n = _wlbIdx + d; if (n < 0 || n >= _wlbList.length) return; _wlbIdx = n; _wlbLoad(); }
  function _wlbLoad() {
    var it = _wlbList[_wlbIdx]; if (!it) return;
    var v = _wlb.__v;
    v.src = it.src; v.muted = false; _wlb.__fill.style.width = '0%';
    _wlb.querySelector('.worn-lb__cap').textContent = it.label || '';
    _wlb.querySelector('.worn-lb__nav--prev').style.visibility = _wlbIdx > 0 ? 'visible' : 'hidden';
    _wlb.querySelector('.worn-lb__nav--next').style.visibility = _wlbIdx < _wlbList.length - 1 ? 'visible' : 'hidden';
    _wlb.__syncMute();
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function _wlbEnsure() {
    if (_wlb) return;
    _wlb = document.createElement('div');
    _wlb.className = 'worn-lb';
    _wlb.innerHTML =
      '<button type="button" class="worn-lb__close" aria-label="close">×</button>' +
      '<button type="button" class="worn-lb__nav worn-lb__nav--prev" aria-label="previous clip">‹</button>' +
      '<button type="button" class="worn-lb__nav worn-lb__nav--next" aria-label="next clip">›</button>' +
      '<div class="worn-lb__stage">' +
        '<div class="worn-lb__frame">' +
          '<video class="worn-lb__video" playsinline webkit-playsinline preload="auto"></video>' +
          '<span class="worn-lb__big" aria-hidden="true"><svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>' +
        '</div>' +
        '<div class="worn-lb__bar">' +
          '<button type="button" class="worn-lb__mute" aria-label="toggle sound"></button>' +
          '<div class="worn-lb__track"><span class="worn-lb__fill"></span></div>' +
        '</div>' +
        '<span class="worn-lb__cap"></span>' +
      '</div>';
    document.body.appendChild(_wlb);
    var v = _wlb.querySelector('.worn-lb__video');
    var fill = _wlb.querySelector('.worn-lb__fill');
    var track = _wlb.querySelector('.worn-lb__track');
    var muteBtn = _wlb.querySelector('.worn-lb__mute');
    var frame = _wlb.querySelector('.worn-lb__frame');
    var spkOn = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4z" fill="currentColor" stroke="none"/><path d="M15.5 8.5a5 5 0 010 7"/></svg>';
    var spkOff = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4z" fill="currentColor" stroke="none"/><path d="M22 9l-6 6M16 9l6 6"/></svg>';
    function syncMute() { muteBtn.innerHTML = v.muted ? spkOff : spkOn; }
    function togglePlay() { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
    frame.addEventListener('click', togglePlay);
    v.addEventListener('play', function () { _wlb.classList.remove('is-paused'); });
    v.addEventListener('pause', function () { _wlb.classList.add('is-paused'); });
    v.addEventListener('timeupdate', function () { if (v.duration) fill.style.width = (v.currentTime / v.duration * 100) + '%'; });
    v.addEventListener('ended', function () { if (_wlbIdx < _wlbList.length - 1) _wlbGo(1); else _wlb.classList.add('is-paused'); });
    muteBtn.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; syncMute(); });
    track.addEventListener('click', function (e) { e.stopPropagation(); var r = track.getBoundingClientRect(); var f = (e.clientX - r.left) / r.width; if (v.duration) v.currentTime = Math.max(0, Math.min(1, f)) * v.duration; });
    _wlb.querySelector('.worn-lb__close').addEventListener('click', _wlbClose);
    _wlb.querySelector('.worn-lb__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); _wlbGo(-1); });
    _wlb.querySelector('.worn-lb__nav--next').addEventListener('click', function (e) { e.stopPropagation(); _wlbGo(1); });
    _wlb.addEventListener('click', function (e) { if (e.target === _wlb) _wlbClose(); });
    document.addEventListener('keydown', function (e) {
      if (!_wlb.classList.contains('is-open')) return;
      if (e.key === 'Escape' || e.keyCode === 27) _wlbClose();
      else if (e.key === 'ArrowRight') _wlbGo(1);
      else if (e.key === 'ArrowLeft') _wlbGo(-1);
    });
    var sx = null;
    frame.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    frame.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 45) _wlbGo(dx < 0 ? 1 : -1); sx = null; });
    _wlb.__v = v; _wlb.__fill = fill; _wlb.__syncMute = syncMute;
  }
  function openWornLightbox(list, idx) {
    if (!list || !list.length) return;
    _wlbEnsure();
    _wlbList = list; _wlbIdx = idx || 0;
    _wlb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
    _wlbLoad();
  }

  function initRail(rail) {
    if (rail.__wornInit) return;
    rail.__wornInit = true;
    var track = rail.querySelector('[data-worn-track]');
    if (!track) return;
    var realCards = Array.prototype.slice.call(track.querySelectorAll('[data-worn-card]'));
    var N = realCards.length;
    if (!N) return;

    // ── Infinite loop ──────────────────────────────────────────────
    // Clone one full set of cards before AND after the real set so the rail
    // cycles endlessly in both directions. The real set stays in the middle;
    // once a swipe/arrow settles inside a clone zone we teleport the scroll
    // position back by exactly one set-width. Clones are pixel-identical, so
    // the teleport is invisible — reaching the end just flows into the start.
    var loop = N >= 2;
    realCards.forEach(function (c, i) { c.setAttribute('data-loop-i', i); });
    var allCards = realCards.slice();
    if (loop) {
      var pre = document.createDocumentFragment();
      var post = document.createDocumentFragment();
      realCards.forEach(function (c) {
        [pre, post].forEach(function (frag) {
          var cl = c.cloneNode(true);
          cl.setAttribute('data-worn-clone', 'true');
          cl.setAttribute('aria-hidden', 'true');
          var foc = cl.querySelectorAll('a, button');
          for (var j = 0; j < foc.length; j++) foc[j].setAttribute('tabindex', '-1');
          frag.appendChild(cl);
        });
      });
      track.insertBefore(pre, realCards[0]);
      track.appendChild(post);
      allCards = Array.prototype.slice.call(track.querySelectorAll('[data-worn-card]'));
    }

    var dotsWrap = rail.querySelector('[data-worn-dots]');
    var dots = [];

    function stride() {
      return allCards.length > 1 ? (allCards[1].offsetLeft - allCards[0].offsetLeft) : (allCards[0].offsetWidth || 1);
    }
    // Which card is nearest the viewport CENTRE (the one we scale up as
    // "selected"). Measured from live rects, so it's correct regardless of the
    // track's offsetParent / padding.
    function centeredIndex() {
      var trc = track.getBoundingClientRect();
      var r0 = allCards[0].getBoundingClientRect();
      var mid = trc.left + trc.width / 2;
      var c0 = r0.left + r0.width / 2;
      return Math.round((mid - c0) / stride());
    }
    // Scroll so card `idx` is centred in the viewport, by the exact measured
    // delta — no offset/padding assumptions.
    // Instantly reposition, bypassing the track's CSS scroll-behavior:smooth, so
    // loop teleports and the initial park never animate into a visible scroll.
    function jumpBy(px) {
      if (!px) return;
      var _sb = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft += px;
      void track.offsetWidth; // commit the jump before smooth is restored (Safari)
      track.style.scrollBehavior = _sb;
    }
    function scrollToIndex(idx, smooth) {
      var t = allCards[idx];
      if (!t) return;
      var trc = track.getBoundingClientRect(), cr = t.getBoundingClientRect();
      var delta = (cr.left + cr.width / 2) - (trc.left + trc.width / 2);
      if (smooth) track.scrollBy({ left: delta, behavior: 'smooth' });
      else jumpBy(delta);
    }

    // Park with the first real card CENTRED; a full set of clones sits on each
    // side to scroll into before we teleport.
    if (loop) scrollToIndex(N, false);

    if (dotsWrap) {
      for (var di = 0; di < N; di++) {
        (function (i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'worn-dot';
          d.setAttribute('aria-label', 'go to item ' + (i + 1));
          d.addEventListener('click', function () { scrollToIndex((loop ? N : 0) + i, true); });
          dotsWrap.appendChild(d);
          dots.push(d);
        })(di);
      }
    }

    // Once a scroll has settled, snap the position back into the middle set if
    // it drifted into a clone zone. Done on settle (not mid-momentum) so iOS
    // momentum scrolling isn't interrupted; the identical clones mean the jump
    // is never visible.
    function normalize() {
      if (!loop) return;
      var st = stride();
      if (st <= 0) return;
      var c = centeredIndex(), nc = c;
      while (nc < N) nc += N;
      while (nc >= 2 * N) nc -= N;
      // The teleport back into the real set MUST be instant — jumpBy bypasses
      // the track's CSS scroll-behavior:smooth so the rail never visibly scrolls
      // back to the start; identical clones are swapped for the real cards with
      // zero perceptible movement.
      if (nc !== c) jumpBy((nc - c) * st);
    }

    var raf = null, settleT = null;
    function updateActive() {
      var raw = centeredIndex();
      if (raw < 0) raw = 0;
      if (raw > allCards.length - 1) raw = allCards.length - 1;
      allCards.forEach(function (card, i) { card.classList.toggle('is-active', i === raw); });
      var realIdx = loop ? (((raw - N) % N) + N) % N : Math.max(0, Math.min(N - 1, raw));
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === realIdx); });
    }
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(function () { raf = null; updateActive(); });
      if (settleT) clearTimeout(settleT);
      settleT = setTimeout(function () { normalize(); updateActive(); }, 90);
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { normalize(); updateActive(); });
    window.addEventListener('resize', function () { normalize(); onScroll(); });

    var prev = rail.querySelector('[data-worn-prev]');
    var next = rail.querySelector('[data-worn-next]');
    function step(dir) { scrollToIndex(centeredIndex() + dir, true); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Video tap → open the lightbox at the correct REAL clip; a tapped clone
    // maps back to its original via data-loop-i.
    var videoRealCards = realCards.filter(function (c) { return c.getAttribute('data-type') === 'video'; });
    var playlist = videoRealCards.map(function (c) {
      var l = c.querySelector('.worn-card__label');
      return { src: c.getAttribute('data-video-mp4') || c.getAttribute('data-video-src'), label: l ? l.textContent.trim() : '' };
    });
    allCards.forEach(function (card) {
      var type = card.getAttribute('data-type');
      if (type === 'video') {
        var tap = card.querySelector('.worn-card__tap') || card;
        tap.addEventListener('click', function (e) {
          e.preventDefault();
          var li = parseInt(card.getAttribute('data-loop-i'), 10);
          var realCard = (li >= 0 && realCards[li]) ? realCards[li] : card;
          openWornLightbox(playlist, Math.max(0, videoRealCards.indexOf(realCard)));
        });
      } else if (type === 'review' && card.getAttribute('data-scroll-reviews') === 'true') {
        card.addEventListener('click', function (e) {
          var target = document.querySelector('.jdgm-review-widget, .judgeme-review-section, #reviews, [id^="judgeme"]');
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      }
    });

    updateActive();
  }

  function hydratePosters(rail) {
    var posters = rail.querySelectorAll('img[data-worn-src]');
    for (var i = 0; i < posters.length; i++) {
      var poster = posters[i];
      var srcset = poster.getAttribute('data-worn-srcset');
      if (srcset) poster.setAttribute('srcset', srcset);
      poster.setAttribute('src', poster.getAttribute('data-worn-src'));
      poster.removeAttribute('data-worn-src');
      poster.removeAttribute('data-worn-srcset');
    }
  }

  function observe(rail) {
    if (!('IntersectionObserver' in window)) { hydratePosters(rail); initRail(rail); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { hydratePosters(rail); initRail(rail); io.disconnect(); } });
    }, { rootMargin: '100px 0px' });
    io.observe(rail);
  }

  function boot() {
    var rails = document.querySelectorAll('[data-worn-rail]');
    for (var i = 0; i < rails.length; i++) observe(rails[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
